// client/src/routes/index.tsx — "/" · UI-003, completed by AUTH-004 (04 §9.2).
//
// §9.2 specifies this route as a redirect: authed → `/app/dashboard`, else → `/login`. UI-003
// delivered the first branch and left the second as a comment, because until AUTH-004 there
// was no `/login` to send anyone to and no way to BE unauthenticated. Both exist now, and the
// guard awaits the bootstrap so a hard refresh with a live refresh cookie lands in the app
// rather than on the login page.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { landingFor } from '@/features/auth/redirect';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const session = await ensureSession();
    // `landingFor`, not `DEFAULT_LANDING`: an account that only rents lands in the portal, and
    // the console is the wrong first screen for it (D-1732).
    throw session ? redirect({ href: landingFor(session) }) : redirect({ to: '/login' });
  },
});
